import { faAngleDoubleRight } from '@fortawesome/pro-solid-svg-icons/faAngleDoubleRight';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { Link } from 'react-router-dom-v5-compat';

import { Breadcrumbs } from 'ui-components/components/breadcrumbs';
import { Text, TextType } from 'ui-components/components/text';

import { BASE_PRODUCTS_PATH, TRANSFER_ORDERS_PATH } from '../../../../../../routes/constants';
import { messages } from './transfer-order-breadcrumb.messages';
import styles from './transfer-order-breadcrumb.styles.module.less';

type TransferOrderBreadcrumbProps = {
  orderNumber: string;
};

const TransferOrdersBaseRoute = `${BASE_PRODUCTS_PATH}${TRANSFER_ORDERS_PATH}`;

export const TransferOrderBreadcrumb = ({ orderNumber }: TransferOrderBreadcrumbProps) => {
  return (
    <div className={styles.breadcrumb}>
      <Breadcrumbs separator={<FontAwesomeIcon className={styles.separator} icon={faAngleDoubleRight} />}>
        <Link className={styles.link} to={TransferOrdersBaseRoute}>
          <Text className={styles['breadcrumb-font']} textType={TextType.Paragraph} value={messages.breadcrumbTransferOrders} />
        </Link>
        <Text
          className={styles['breadcrumb-font']}
          formattedMessageValues={{ orderId: orderNumber }}
          textType={TextType.Paragraph}
          value={messages.orderNumberHeader}
        />
      </Breadcrumbs>
    </div>
  );
};
